import { createContent, ordinalIndicator } from '@altify/utils';
import { getWeekdayName } from 'app/_authenticated/trade/recurring-buy/helpers/weekdays';
import { RecurringBuySchedule } from 'app/_authenticated/trade/recurring-buy/models/RecurringBuySchedule';

export const sharedContent = createContent({
  en: {
    //title: 'Recurring Buy',
    createRecurringBuy: 'Create Recurring Buy',
    createWeeklyOrMonthly: 'Create a weekly or monthly recurring buy',
    recurringBuys: 'Recurring Buys',
    recurringBuy: 'Recurring Buy',
    backToPortfolio: 'Back to Portfolio',
    viewPortfolio: 'View Portfolio',
    active: 'Active',
    paused: 'Paused',
    intervalReadable: (time: RecurringBuySchedule) =>
      time.interval == 'weekly'
        ? `Weekly on ${getWeekdayName(time.dayOfWeek, 'en')}s`
        : `Monthly on the ${time.dayOfMonth}${ordinalIndicator(
          time.dayOfMonth,
        )}`,
    of: 'of',
  },
  de: {
    //title: 'Wiederkehrender Kauf',
    createRecurringBuy: 'Wiederkehrenden Kauf erstellen',
    createWeeklyOrMonthly: 'Create a Weekly or Monthly Recurring Buy',
    recurringBuy: 'Wiederkehrender Kauf',
    recurringBuys: 'Wiederkehrende Käufe',
    backToPortfolio: 'Zurück zum Portfolio',
    viewPortfolio: 'Zum Portfolio',
    active: 'Aktiv',
    paused: 'Pausiert',
    intervalReadable: (time: RecurringBuySchedule) =>
      time.interval == 'weekly'
        ? `Wöchentlich am ${getWeekdayName(time.dayOfWeek, 'de')}`
        : `Monatlich am ${time.dayOfMonth}.`,
    of: 'von',
  },
});
